<img
  ngSrc="{{ imageSrc }}"
  [height]="height"
  [width]="width"
  [priority]="priority"
/>
